// Which Team layout a warehouse gets (Alex, 2026-10-20; plan
// .claude/plans/feat-sorter-dashboard.md). Keyed by name like the BE's
// dashboardLayoutOf (app/admin/services/sorter-dashboard.js) and the Pick
// Advisor's Pembroke check — the two lists must agree.
//
//   picking — Pembroke and "All warehouses": race to the cut-off, drop
//             queues, picking due today, the seven department cards.
//   sorter  — Newport and Poland: a race per sorter station against a
//             target finish, orders out (no due date), six department
//             cards (Goods In, Put Away, Sorter 1, Sorter 2, Dispatch,
//             Pallets Created).
export type DashboardLayout = "picking" | "sorter";

const SORTER_LAYOUT_WAREHOUSES = new Set(["newport", "poland"]);

export const dashboardLayoutOf = (warehouse: string | null | undefined): DashboardLayout =>
    warehouse && SORTER_LAYOUT_WAREHOUSES.has(warehouse.toLowerCase().replace(/[^a-z]/g, ""))
        ? "sorter"
        : "picking";

export const isSorterLayout = (warehouse: string | null | undefined): boolean =>
    dashboardLayoutOf(warehouse) === "sorter";

// Orders Shipped by date (Alex, 2026-10-23): the per-day Jobalots
// placed-vs-shipped tile under the Warehouse KPIs. Poland, and Newport
// too (Portal runs its dispatch from late October 2026) — the BE endpoint
// (/admin/dashboard/shipped-by-date) takes any scope; which
// warehouse shows the tile is decided here, by name like the layout.
const SHIPPED_BY_DATE_WAREHOUSES = new Set(["newport", "poland"]);

export const showsShippedByDate = (warehouse: string | null | undefined): boolean =>
    !!warehouse && SHIPPED_BY_DATE_WAREHOUSES.has(warehouse.toLowerCase().replace(/[^a-z]/g, ""));

// Never offered in the warehouse filter: MCL is a 3PL the dashboard will
// not cover (Alex, 2026-10-20); test warehouses were already hidden.
export const HIDDEN_DASHBOARD_WAREHOUSES = new Set(["mcl"]);

export const dashboardWarehouseShown = (warehouse: string): boolean =>
    !/test/i.test(warehouse) && !HIDDEN_DASHBOARD_WAREHOUSES.has(warehouse.toLowerCase().replace(/[^a-z]/g, ""));
